import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateCustomOrganisationMutation,
  CreateCustomOrganisationMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const CREATE_CUSTOM_ORGANISATION_MUTATION = graphql(`
  mutation createCustomOrganisation($input: CreateCustomOrganisationInput!) {
    createCustomOrganisation(input: $input) {
      id
      name
    }
  }
`);

export function useCreateCustomOrganisation(
  options?: UseMutationOptions<
    CreateCustomOrganisationMutation,
    unknown,
    CreateCustomOrganisationMutationVariables,
    unknown
  >,
) {
  return useGraphQlMutation(CREATE_CUSTOM_ORGANISATION_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await options?.onSuccess?.(data, variables, context);
    },
  });
}
